export const zhCNDictionary = {
    lineup: "排列",
    catchphrase: "找到你喜欢的物品",
    guide: {
        title: "购买前请",
        subtitle: "提前检查",
        what_is_service: "Web ROLL是什么？",
        delivery: "关于配送",
        qa: "常见问题",
        contact: "联系我们",
        guide_to_signup: "初次使用请点击这里",
        login: "登录",
        signup: "免费会员注册",
        link_login: "这里登录",
        link_signup: "新会员注册在这里",
        login_sns: "用社交账号登录",
        signup_sns: "用社交账号注册",
        email_login: "用电子邮件登录",
        email_signup: "用电子邮件注册会员",
        google_login_support: "不能用Google登录的客户",
        login_form: {
            email: "电子邮件",
            password: "密码",
            login_button: "用电子邮件登录",
            signup_button: "用电子邮件注册会员",
            agree: "同意",
            forgot_password: "如果您忘记了密码"
        },
        login_alert: {
            title: "注册为会员\n可以使用\nWeb ROLL",
            description: "可以通过SNS轻松注册",
            login_button: "登录",
            signup_button: "免费会员注册"
        }
    },
    gacha: {
        selling_status: {
            ended: "销售已结束",
            selling: {
                day: "还有{{value}}天",
                hour: "还有{{value}}小时",
                minute: "还有{{value}}分钟",
                absolute: "( 截止日期：{{date}} )"
            },
            comingsoon: {
                day: "距离销售开始还有{{value}}天",
                hour: "距离销售开始还有{{value}}小时",
                minute: "距离销售开始还有{{value}}分钟",
                absolute: "( 预定开始日期：{{date}} )"
            },
            play_limit: {
                reached_play_limit: "您已达到今日购买上限",
                remaining_play_limit: "今日剩余购买次数：{{value}}次"
            },
        },
        description: {
            more: "更多",
            close: "关闭"
        }
    },
    gift_code: {
        input: {
            title: "输入礼品码",
            cancel: "取消",
            scan_qr: "扫描QR码",
            submit: "添加到账户",
            code_placeholder: "在此输入礼品码号",
            require_code_error: "请输入礼品码",
            or: "或者"
        }
    },
    global: {
        header: {
            history: "购买历史",
            menu: "选单",
            signup_or_login: "免费会员注册/登录",
            menus: {
                mypage: "我的页面",
                logout: "登出",
                login: "登录",
                signup: "免费会员注册",
                acquired_items: "已获得的物品",
                input_code: "代码输入",
                gift_code: "礼品码",
                play_ticket: "免费票",
                prize_ticket: "票券/优惠券",
                user_id: "用户ID : {{id}}"
            }
        },
        footer: {
            company: "公司概述",
            privacy: "隐私政策",
            terms: "使用条款",
            contact: "联系我们",
            specified_commercial_transactions: "基于特定商业交易法的表述"
        },
        login: {
            status: {
                google: "已用Google账户登录",
                password: "已用电子邮件地址登录",
                unknown: "没有登录信息"
            },
            success: "登录成功",
            error: {
                title: "登录失败",
                description: "如果问题持续存在，请使用其他认证方法。"
            }
        },
        signup: {
            error: {
                title: "注册失败",
                description: "如果问题持续存在，请使用其他认证方法。"
            }
        },
        common: {
            tax: {
                included: "含税",
                excluded: "不含税"
            },
            piece: "次",
            sum: "总计",
            delivery_fee: "运费",
            prize_unit: "个",
            remain_delivery_count: "多达 {{bundle_amount}} 品免运费",
            jst_date_warning: "所有时间均为日本标准时间(JST)",
            ok: "确认",
            cancel: "取消",
            register: "注册",
            submit: "传动",
            company: "公司概述",
            privacy: "隐私政策",
            terms: "使用条款",
            contact: "联系我们",
            specified_commercial_transactions: "基于特定商业交易法的表述"
        },
        adult_contents: {
            question_of_adulthood: {
                title: "您是否已满18岁？",
                description: "除了一般作品外，还包含暴力和性描述等不适合18岁以下人士观看的信息。"
            },
            contents_switch: {
                general: "一般向",
                adult: "成人内容(R-18)"
            }
        }
    },
    components: {
        view_registered_address: "查看已注册的配送地址",
        shipping_forms: {
            country: "配送国家",
            name: "姓名",
            phone: "电话号码",
            zip_code: "邮编",
            email: "电子邮件地址",
            full_address: "地址",
            prefecture: "省份",
            city: "市县镇",
            address1: "街道、门牌号",
            address2: "公寓/大厦/房间号",
            auto_fill: "地址搜索",
            errors: {
                is_required: "必填项",
                address_auto_fill_not_in_service: "地址搜索仅适用于日本邮政编码",
                is_invalid_phone_number: "请输入有效的电话号码",
                is_invalid_email: "请输入有效的电子邮件地址",
                is_invalid_zip_code: "请输入3到9位的数字"
            }
        },
        shipments: {
            title: "配送信息",
            about_bundle_capacity: "每【{{amount}}个】商品",
            about_fee: "关于运费",
            about_fee_detail: "▼关于运费详情",
            period: "▼预计配送时间"
        },
        order_info: {
            play_ticket: "免费票",
            order_date: "购买日期:",
            play_amount: {
                single: "{抽取{{amount}}次",
                multi: "连续抽取{{amount}}次"
            },
            payment_method: {
                label: "支付方式:",
                no_info: "没有支付信息"
            },
            delivery: {
                label: "交货状态:",
                title: {
                    delivery: "交货状态:",
                    local_pickup: "收货状态:"
                },
                status: {
                    not_shipped: "未发货",
                    shipped: "运到",
                    not_picked: "未领取",
                    picked: "在接收之前",
                    no_delivery: "置为不发货的订单"
                }
            }
        }
    },
    pages: {
        gacha: {
            prizes: {
                about: "关于商品",
                lineup: "商品列表",
                view_collection: "查看已获得的物品"
            },
            purchase_benefits: "购买特典",
            collection_items: "获奖商品",
            collection: "收藏",
            "ticket/coupon": "票券・优惠券",
            guide_to_collection: "获奖的数字内容、票券、优惠券可在\"获奖商品\"中找到",
            delivery: {
                price: "运费",
                detail: "关于运费"
            },
            play: {
                single: "抽取{{amount}}次",
                multi: "连续抽取{{amount}}次",
                single_lottery: "抽取{{amount}}次",
                multi_lottery: "连续抽取{{amount}}次",
                button: "购买",
                view_play_buttons: "购买这个抽奖",
                has_play_ticket: "您可以使用免费票"
            },
            unplayable: {
                comingsoon: "即将推出",
                discontinued: "销售已结束",
                soldout: "已售罄",
                closing: "目前不出售"
            },
            result: {
                title: "抽奖结果"
            }
        },
        onePass: {
            invalid_format: "请输入正确的格式",
            please_enter: "输入授权码",
            please_login: "请登录使用本网站",
            send_error: "发送失败"
        },
        local_pickup: {
            qr_code_title: "取货 QR 码",
            qr_code_description: "请将此 QR 码出示给现场工作人员以领取商品",
            display_qr_code: "显示取货 QR 码",
            pickup_code: "代码：",
            user_reference_number: "您的参考号码：",
            calling_reference_number: "呼叫中的参考号码：",
            pickup_location: "取货地点：",
            pickup_location_detail: "取货地点详情",
            enter_prize_pickup: "进入领奖",
            local_pickup_description: "此抽奖仅限会场领取"
        },
        check_in: {
            title: "签到",
            modal: {
                title: "此抽奖仅限参会者",
                description: "到达会场后，请点击'签到'以确认您的到达",
                check_in_progress_1: "您是否在会场附近，",
                check_in_progress_2: "正在检查..."
            },
            result: {
                success: "签到成功",
                not_nearby: {
                    title: "签到失败",
                    description: "请在会场附近再试一次"
                },
                permission_denied: {
                    title: "未获得位置信息权限",
                    ios_description: "请前往浏览器设置->网站设置->位置信息并选择允许，然后再试一次",
                    android_description: "启动设置应用，前往应用与通知->高级->应用权限->位置信息，为Chrome开启位置信息后重新加载页面并再试一次"
                },
                get_location_failed: {
                    title: "获取位置信息失败",
                    description: "请再试一次"
                }
            }
        },
        prize_ticket: {
            no_available_ticket: "没有可用的票券/优惠券",
            used_ticket: "已使用的票券/优惠券"
        },
        my_page: {
            title: "账户",
            nickname: {
                edit: "编辑昵称",
                register: "注册昵称"
            },
            user_id: "用户ID",
            shipping_info: {
                title: "配送信息",
                register: "注册配送信息",
                edit: "编辑配送信息"
            },
            delete_account: {
                title: "删除账户",
                modal: {
                    title: "您确定要删除您的账户吗？",
                    description: "删除账户后，所有注册的个人信息和购买历史将被删除，您将无法访问或下载任何已购买的数字内容。未发货的商品将按正常流程发货。",
                    agree: "同意",
                    confirm: "删除账户",
                    cancel: "取消",
                    success: {
                        title: "账户删除成功",
                        description: "感谢您的使用"
                    },
                    error: {
                        title: "账户删除失败",
                        description: "请重新登录并再试一次"
                    }
                }
            }
        },
        buy: {
            title: "填写配送信息",
            submit_title: "购买",
            buy_again: "再次购买",
            return_to_top: "返回顶部",
            cancel: "取消",
            check_warning: {
                title: "注意事项",
                form_title: "我已确认注意事项"
            },
            shippings: {
                title: "配送信息",
                different_address_warning: "更改配送地址会产生运费",
                cannot_ship_warning: "所选的抽奖无法配送到您账户中注册的地址，请输入可配送的地址。",
                forms: {
                    country: "配送国家",
                    name: "姓名"
                },
                no: {
                    title: "不配送中奖商品",
                    description: "只能查看数字内容。",
                    warning: "中奖商品将不会被配送，请注意。",
                    confirm_title: "是否确认不配送中奖商品？",
                    confirm_description: "只能查看数字内容。如果您不希望收到中奖商品的配送，可以选择此项。"
                }
            },
            payments: {
                title: "支付方式",
                methods: {
                    credit: "信用卡",
                    paypay: "PayPay",
                    carrier: "运营商支付",
                    unionpay: "UnionPay"
                },
                credit: {
                    title: "信用卡信息",
                    cardno: "卡号",
                    exp: "有效期限",
                    holder_name: "持卡人姓名",
                    security_code: "安全码",
                    what_is_security_code: "什么是安全码",
                    quantity_full: "请在注册新的信用卡前删除已注册的卡",
                    register_card: "注册信用卡信息",
                    supported_card_text: "支持以下信用卡"
                },
                carrier: {
                    title: "选择运营商支付"
                },
                purchase_detail_description: {
                    credit: "※信用卡明细将显示为\"SWAMP STORE\"。\n\"SWAMP STORE\"是此服务的购买明细。",
                    app: "※App明细将显示为\"SWAMP STORE\"。\n\"SWAMP STORE\"是此服务的购买明细。"
                }
            },
            tipping_message: {
                title: "向卖家发送消息",
                placeholder: "输入你的消息",
                invalid_length: "消息太长了",
                caution: "此消息可能会在创作者的直播中使用，请不要输入任何不当内容。"
            }
        },
        history: {
            title: "购买历史",
            no_history: "没有购买历史",
            guide_to_collection: "您赢得的数字内容可以从获得的商品中查看",
            items_not_yet_received: "尚未收到的商品",
            order_detail: {
                title: "订单详情"
            }
        }
    },
    country: {
        JP: "日本",
        US: "美国",
        CN: "中国",
        KR: "韩国",
        TW: "台湾",
        HK: "香港"
    },
    errors: {
        "404": {
            title: "指定的URL页面不存在",
            description: "URL可能错误，或者页面可能已被删除。如果问题仍然存在，请从帐户 > 联系我们进行联系。"
        },
        "500": {
            title: "发生错误",
            description: "如果问题未解决，请通过菜单 > 联系我们进行咨询。"
        },
        not_found: {
            title: "指定的URL页面不存在",
            description: "URL可能错误，或者页面可能已被删除。如果问题仍然存在，请从帐户 > 联系我们进行联系。"
        },
        failed: {
            check_in: "报到失败。",
            get_gacha_detail: "检索事件信息失败。",
            get_gacha_history: "检索购买历史失败"
        }
    }
};
